import Settings from 'components/settings/Settings';
import PasswordChangeSuccessOverlay from 'components/auth/PasswordChangeSuccessOverlay';
import NewPageContent from 'layouts/NewPageContent';

export default function ListSetting() {
  return (
    <>
      <NewPageContent breadcrumbs={[{ label: 'Settings', to: '' }]} documentTitle="Settings">
        <Settings />
      </NewPageContent>
      <PasswordChangeSuccessOverlay />
    </>
  );
}
